module.exports = __webpack_public_path__ + "static/40invgde-bc8fbb45ab5b73d7efe3c951e324d6e4.gif";